/**
 * Carrier codes served by LOFT. Kept in one config module rather than hardcoded
 * in components (rev-021), so the business list has a single source of truth.
 */
// hawkeye-suppress: rev-021 — this module IS the central carrier config the rule asks for;
// these literals are the single source of truth, not business constants hardcoded in a component.
export const CARRIERS: string[] = ['ABR', 'ABX', 'ASA', 'ATN', 'CJT', 'CSB', 'SCX'];
